import { Injectable } from '@angular/core';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import jwtDecode from 'jwt-decode';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected readonly router: Router,
    protected readonly keycloak: KeycloakService,
    protected readonly storageService: StorageService,
    private authService: AuthService
  ) {
    super(router, keycloak);
  }

  async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (!this.authenticated) {
      this.router.navigate(['public/_home']);
    } else {
      const companyIdFromUrl = route.queryParamMap.get('companyId');
      if (companyIdFromUrl && !this.storageService.getCompanyName()) {
        this.storageService.setCompanyId(companyIdFromUrl);
        try {
          const token = await this.keycloak.getToken();
          const data: any = jwtDecode(token);
          const match = (data?.companies || []).find((c: any) => c.id === companyIdFromUrl);
          if (match?.name) {
            this.storageService.setCompanyName(match.name);
          }
        } catch {}
        const pathOnly = state.url.split('?')[0];
        this.storageService.setUrlReload(pathOnly);
        this.router.navigate(['multicompany']);
        return false;
      }
      if (!this.storageService.getCompanyId()) {
        if (this.router.url === '/multicompany') {
          return this.authenticated;
        } else {
          this.authService.isAdmin().subscribe((isAdmin) => {
            if (isAdmin === false) {
              if (state.url && state.url !== '/multicompany') {
                this.storageService.setUrlReload(state.url);
              }
              this.router.navigate(['multicompany']);
              return false;
            } else {
              return true;
            }
          });
        }
      } else {
        return this.authenticated;
      }
    }
  }
}
